import React, { useState } from 'react'
import Dialog from '../../dialog/Dialog'
import ButtonStartIcon from '../../button/ButtonStartIcon'
import isEmpty from 'lodash/isEmpty'
import Typography from '@mui/material/Typography'
import { validate } from '../../../utils'
import InputPassword from '../../FormControl/input/InputPassword'
import { handlerErrorV2 } from '../../../utils/errors'
import { updatePasswordProfile } from '../../../services/auth/auth.service'
import { Alert } from '@mui/material'

const DialogUpdatePassword = ({ show, onClose }) => {
  const [form, setForm] = useState({ newPassword: '', newPasswordConfirmation: '' })
  const [errors, setInputErrors] = useState()
  const [loading, setLoading] = useState(false)

  const onChange = (e) => {
    const { name, value } = e.target
    setForm({ ...form, [name]: value })
    setInputErrors({ ...errors, [name]: null })
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    const fieldRules = {
      newPassword: 'required|password',
      newPasswordConfirmation: `required|match:${form.newPassword}`,
    }

    const errors = validate(fieldRules, form)
    if (!isEmpty(errors)) {
      setInputErrors(errors)
      return
    }

    try {
      setLoading(true)
      const result = await updatePasswordProfile(form);;
      setLoading(false)
      if (!result.data && result.error) {
        setInputErrors({ message: result.error.message || 'An error occurred' })
      } else {
        onClose()
        enqueueSnackbar('Password changed successfully', { variant: 'success' })
      }
    } catch (error) {
      setLoading(false)
      const message = handlerErrorV2(error)
      setInputErrors({ message })
    }
  }

  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        disabled={loading}
        startIcon={["fal","times"]}
      >
        Cancel
      </ButtonStartIcon>
      <ButtonStartIcon
        onClick={onSubmit}
        color='primary'
        variant='contained'
        loading={loading}
        startIcon={["fal","check"]}
      >
        Confirm
      </ButtonStartIcon>
    </>
  )
  return (
    <Dialog
      id="update-password"
      show={show} 
      title="Update password"
      onClose={onClose}
      actions={Actions}
    >
      <div className='flex flex-col gap-4 py-4'>
        <div className='grid grid-cols-3 items-start gap-4'>
          <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
            New password
          </Typography>
          <div className='col-span-2'>
            <InputPassword
              id='new-password'
              name='newPassword'
              value={form.newPassword}
              error={errors?.newPassword}
              helperText={errors?.newPassword}
              onChange={onChange}
              fullWidth
            />
          </div>
        </div>
        <div className='grid grid-cols-3 items-start gap-4'>
          <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
            Confirm password
          </Typography>
          <div className='col-span-2'>
            <InputPassword
              id='confirm-password'
              name='newPasswordConfirmation'
              value={form.newPasswordConfirmation}
              error={errors?.newPasswordConfirmation}
              helperText={errors?.newPasswordConfirmation}
              onChange={onChange}
              fullWidth
            />
          </div>
        </div>
      </div>
      { errors?.message &&
        <Alert severity="error" onClose={() => setInputErrors({ message: null })}>
          {errors.message}
        </Alert>
      }
    </Dialog>
  )
}

export default DialogUpdatePassword